module.exports = __webpack_public_path__ + "assets/dcb92e6cfa9d44ac0ad6ec2afa93cb67.mp4";